import { AppState } from "../../interfaces/app.interface";
import { UpdateAppStateAction } from "./appActions";
import * as actionTypes from './appActionTypes';

type AppActions = UpdateAppStateAction | { type: string; payload?: any };

const initialState: AppState = {
  selectedMode: null,
  companyId: null,
  currentLocation: null,
  favoriteRestaurantId: null,
};

export default function appReducer(state = initialState, action: AppActions): AppState {
  switch (action.type) {
    case actionTypes.UPDATE_APP_STATE:
      return { ...state, ...action.payload }; 
    case actionTypes.FETCH_LOCATION_SUCCESS:
      return { ...state, currentLocation: action.payload };
    default:
      return state;
  }
}
